import template from './sw-cms-el-config-top-finder-selectboxes.html.twig';
import './sw-cms-el-config-top-finder-selectboxes.scss';

export default {
    template,

    props: {
        element: {
            type: Object,
            required: true,
        },
    },
};
